import { provideGlameraIcons } from '@glamera/animated-icons';
import { GLM_SEARCH } from '@glamera/animated-icons/search';
import { GLM_SEARCH_DOLLAR } from '@glamera/animated-icons/search-dollar';
import { GLM_HEART } from '@glamera/animated-icons/heart';
import { GLM_HEART_PULSE } from '@glamera/animated-icons/heart-pulse';
import { GLM_HEART_MINUS } from '@glamera/animated-icons/heart-minus';
import { GLM_HEART_PLUS } from '@glamera/animated-icons/heart-plus';
import { GLM_HEART_OFF } from '@glamera/animated-icons/heart-off';
import { GLM_HEART_HANDSHAKE } from '@glamera/animated-icons/heart-handshake';
import { GLM_HAND_HEART } from '@glamera/animated-icons/hand-heart';
import { GLM_HISTORY } from '@glamera/animated-icons/history';
import { GLM_BELL } from '@glamera/animated-icons/bell';
import { GLM_BOOK_HEART } from '@glamera/animated-icons/book-heart';
import { GLM_BUILDING_OFFICE } from '@glamera/animated-icons/building-office';
import { GLM_CHECK } from '@glamera/animated-icons/check';
import { GLM_CHECK_CHECK } from '@glamera/animated-icons/check-check';
import { GLM_CIRCLE_CHECK_BIG } from '@glamera/animated-icons/circle-check-big';
import { GLM_SETTINGS } from '@glamera/animated-icons/settings';
import { GLM_MOON } from '@glamera/animated-icons/moon';
import { GLM_SUN } from '@glamera/animated-icons/sun';
import { GLM_SMARTPHONE } from '@glamera/animated-icons/smartphone';
import { GLM_STAR } from '@glamera/animated-icons/star';
import { GLM_STORE } from '@glamera/animated-icons/store';
import { GLM_SHOPPING_CART } from '@glamera/animated-icons/shopping-cart';
import { GLM_REPEAT } from '@glamera/animated-icons/repeat';
import { GLM_ROTATE_CCW } from '@glamera/animated-icons/rotate-ccw';
import { GLM_ROTATE_CW } from '@glamera/animated-icons/rotate-cw';
import { GLM_REFRESH_CW } from '@glamera/animated-icons/refresh-cw';
import { GLM_MAIL } from '@glamera/animated-icons/mail';
import { GLM_MESSAGE_CIRCLE_MORE } from '@glamera/animated-icons/message-circle-more';
import { GLM_MESSAGE_CIRCLE_HEART } from '@glamera/animated-icons/message-circle-heart';
import { GLM_LOCK } from '@glamera/animated-icons/lock';
import { GLM_LOCK_OPEN } from '@glamera/animated-icons/lock-open';
import { GLM_EYE } from '@glamera/animated-icons/eye';
import { GLM_EYE_CLOSED } from '@glamera/animated-icons/eye-closed';
import { GLM_EYE_OFF } from '@glamera/animated-icons/eye-off';
import { GLM_COPY } from '@glamera/animated-icons/copy';
import { GLM_CREDIT_CARD } from '@glamera/animated-icons/credit-card';
import { GLM_WALLET } from '@glamera/animated-icons/wallet';
import { GLM_CLIPBOARD } from '@glamera/animated-icons/clipboard';
import { GLM_FILE } from '@glamera/animated-icons/file';
import { GLM_FILES } from '@glamera/animated-icons/files';
import { GLM_FINGERPRINT } from '@glamera/animated-icons/fingerprint';
import { GLM_FILE_X } from '@glamera/animated-icons/file-x';
import { GLM_FILE_HEART } from '@glamera/animated-icons/file-heart';
import { GLM_FILE_SPREADSHEET } from '@glamera/animated-icons/file-spreadsheet';
import { GLM_FILE_INVOICE } from '@glamera/animated-icons/file-invoice';
import { GLM_FOLDER_HEART } from '@glamera/animated-icons/folder-heart';
import { GLM_HOUSE } from '@glamera/animated-icons/house';
import { GLM_HOUSE_HEART } from '@glamera/animated-icons/house-heart';
import { GLM_IDENTIFICATION } from '@glamera/animated-icons/identification';
import { GLM_PHONE } from '@glamera/animated-icons/phone';
import { GLM_USER } from '@glamera/animated-icons/user';
import { GLM_USER_ROUND } from '@glamera/animated-icons/user-round';
import { GLM_USER_CHECK } from '@glamera/animated-icons/user-check';
import { GLM_USER_ROUND_CHECK } from '@glamera/animated-icons/user-round-check';
import { GLM_USER_X } from '@glamera/animated-icons/user-x';
import { GLM_USER_PLUS } from '@glamera/animated-icons/user-plus';
import { GLM_USER_ROUND_X } from '@glamera/animated-icons/user-round-x';
import { GLM_USERS } from '@glamera/animated-icons/users';
import { GLM_USER_GROUP } from '@glamera/animated-icons/user-group';
import { GLM_QR_CODE } from '@glamera/animated-icons/qr-code';
import { GLM_SCAN_QR_CODE } from '@glamera/animated-icons/scan-qr-code';
import { GLM_SCAN_HEART } from '@glamera/animated-icons/scan-heart';
import { GLM_TRASH } from '@glamera/animated-icons/trash';
import { GLM_TRASH_2 } from '@glamera/animated-icons/trash-2';
import { GLM_UPLOAD } from '@glamera/animated-icons/upload';
import { GLM_DOWNLOAD } from '@glamera/animated-icons/download';
import { GLM_DOWNLOAD_CLOUD } from '@glamera/animated-icons/download-cloud';
import { GLM_UPLOAD_CLOUD } from '@glamera/animated-icons/upload-cloud';
import { GLM_DUMBBELL } from '@glamera/animated-icons/dumbbell';
import { GLM_SAVE } from '@glamera/animated-icons/save';
import { GLM_CHEVRON_RIGHT } from '@glamera/animated-icons/chevron-right';
import { GLM_CHEVRON_LEFT } from '@glamera/animated-icons/chevron-left';
import { GLM_ARROW_LEFT } from '@glamera/animated-icons/arrow-left';
import { GLM_ARROW_LEFT_RIGHT } from '@glamera/animated-icons/arrow-left-right';
import { GLM_ARROW_UP_DOWN } from '@glamera/animated-icons/arrow-up-down';
import { GLM_ARROW_DOWN_UP } from '@glamera/animated-icons/arrow-down-up';
import { GLM_ARROW_DOWN_TO_LINE } from '@glamera/animated-icons/arrow-down-to-line';
import { GLM_ARROW_RIGHT } from '@glamera/animated-icons/arrow-right';
import { GLM_CHEVRON_UP } from '@glamera/animated-icons/chevron-up';
import { GLM_CHEVRON_DOWN } from '@glamera/animated-icons/chevron-down';
import { GLM_CIRCLE_CHEVRON_UP } from '@glamera/animated-icons/circle-chevron-up';
import { GLM_CIRCLE_CHEVRON_RIGHT } from '@glamera/animated-icons/circle-chevron-right';
import { GLM_CIRCLE_CHEVRON_LEFT } from '@glamera/animated-icons/circle-chevron-left';
import { GLM_CIRCLE_CHEVRON_DOWN } from '@glamera/animated-icons/circle-chevron-down';
import { GLM_SHARE } from '@glamera/animated-icons/share';
import { GLM_SCREEN_SHARE } from '@glamera/animated-icons/screen-share';
import { GLM_EXPAND } from '@glamera/animated-icons/expand';
import { GLM_SHRINK } from '@glamera/animated-icons/shrink';
import { GLM_CIRCLE_CHECK } from '@glamera/animated-icons/circle-check';
import { GLM_CIRCLE_ALERT } from '@glamera/animated-icons/circle-alert';
import { GLM_CIRCLE_QUESTION_MARK } from '@glamera/animated-icons/circle-question-mark';
import { GLM_LAYERS } from '@glamera/animated-icons/layers';
import { GLM_LIST_FILTER } from '@glamera/animated-icons/list-filter';
import { GLM_LIST_ORDERED } from '@glamera/animated-icons/list-ordered';
import { GLM_SQUARE_PEN } from '@glamera/animated-icons/square-pen';
import { GLM_CLOCK } from '@glamera/animated-icons/clock';
import { GLM_ALARM_CLOCK_CHECK } from '@glamera/animated-icons/alarm-clock-check';
import { GLM_PAPERCLIP } from '@glamera/animated-icons/paperclip';
import { GLM_PENCIL } from '@glamera/animated-icons/pencil';
import { GLM_SQUARE_CHECK_BIG } from '@glamera/animated-icons/square-check-big';
import { GLM_PLAY_CIRCLE } from '@glamera/animated-icons/play-circle';
import { GLM_X_CIRCLE } from '@glamera/animated-icons/x-circle';
import { GLM_X } from '@glamera/animated-icons/x';
import { GLM_PLUS } from '@glamera/animated-icons/plus';
import { GLM_MINUS } from '@glamera/animated-icons/minus';
import { GLM_MONITOR } from '@glamera/animated-icons/monitor';
import { GLM_NETWORK } from '@glamera/animated-icons/network';
import { GLM_THREE_DOTS_HORIZONTAL } from '@glamera/animated-icons/3-dots-horizontal';
import { GLM_THREE_DOTS_VERTICAL } from '@glamera/animated-icons/3-dots-vertical';
import { GLM_CALENDAR_X } from '@glamera/animated-icons/calendar-x';
import { GLM_CALENDAR } from '@glamera/animated-icons/calendar';
import { GLM_CALENDAR_CHECK } from '@glamera/animated-icons/calendar-check';
import { GLM_CALENDAR_HEART } from '@glamera/animated-icons/calendar-heart';
import { GLM_SCAN_TEXT } from '@glamera/animated-icons/scan-text';
import { GLM_PRINTER } from '@glamera/animated-icons/printer';
import { GLM_PRINTER_2 } from '@glamera/animated-icons/printer-2';
import { GLM_TABLE } from '@glamera/animated-icons/table';
import { GLM_COLUMNS_SETTINGS } from '@glamera/animated-icons/columns-settings';

export const appConfig = {
  providers: [
    provideGlameraIcons([
      GLM_SEARCH, GLM_SEARCH_DOLLAR, GLM_HEART, GLM_HEART_PULSE, GLM_HEART_MINUS, GLM_HEART_PLUS, GLM_HEART_OFF, GLM_HEART_HANDSHAKE, GLM_HAND_HEART, GLM_BELL, GLM_BOOK_HEART, GLM_BUILDING_OFFICE, GLM_CHECK, GLM_CHECK_CHECK, GLM_CIRCLE_CHECK_BIG, GLM_SETTINGS, GLM_MOON, GLM_SUN, GLM_SMARTPHONE, GLM_STAR, GLM_STORE, GLM_SHOPPING_CART,
      GLM_REPEAT, GLM_ROTATE_CCW, GLM_ROTATE_CW, GLM_REFRESH_CW, GLM_MAIL, GLM_MESSAGE_CIRCLE_MORE, GLM_MESSAGE_CIRCLE_HEART, GLM_LOCK, GLM_LOCK_OPEN, GLM_EYE, GLM_EYE_CLOSED, GLM_EYE_OFF, GLM_COPY, GLM_CREDIT_CARD, GLM_WALLET, GLM_CLIPBOARD, GLM_FILE, GLM_FILES, GLM_FINGERPRINT, GLM_FILE_X, GLM_FILE_HEART, GLM_FILE_SPREADSHEET, GLM_FILE_INVOICE, GLM_FOLDER_HEART, GLM_HISTORY, GLM_HOUSE, GLM_HOUSE_HEART, GLM_IDENTIFICATION, GLM_PHONE, GLM_USER, GLM_USER_ROUND, GLM_USER_CHECK, GLM_USER_ROUND_CHECK, GLM_USER_X, GLM_USER_PLUS, GLM_USER_ROUND_X, GLM_USERS, GLM_USER_GROUP, GLM_QR_CODE, GLM_SCAN_QR_CODE, GLM_SCAN_HEART, GLM_TRASH, GLM_TRASH_2, GLM_UPLOAD, GLM_DOWNLOAD, GLM_DOWNLOAD_CLOUD, GLM_UPLOAD_CLOUD, GLM_DUMBBELL, GLM_SAVE, GLM_CHEVRON_RIGHT, GLM_CHEVRON_LEFT, GLM_ARROW_LEFT, GLM_ARROW_RIGHT, GLM_ARROW_LEFT_RIGHT, GLM_ARROW_UP_DOWN, GLM_ARROW_DOWN_UP, GLM_ARROW_DOWN_TO_LINE, GLM_CHEVRON_UP, GLM_CHEVRON_DOWN, GLM_CIRCLE_CHEVRON_UP, GLM_CIRCLE_CHEVRON_RIGHT, GLM_CIRCLE_CHEVRON_LEFT, GLM_CIRCLE_CHEVRON_DOWN, GLM_SHARE, GLM_SCREEN_SHARE, GLM_EXPAND, GLM_SHRINK, GLM_CIRCLE_CHECK, GLM_CIRCLE_ALERT, GLM_CIRCLE_QUESTION_MARK, GLM_LAYERS, GLM_LIST_FILTER, GLM_LIST_ORDERED, GLM_SQUARE_PEN, GLM_CLOCK, GLM_ALARM_CLOCK_CHECK, GLM_PAPERCLIP, GLM_PENCIL, GLM_SQUARE_CHECK_BIG, GLM_PLAY_CIRCLE, GLM_X_CIRCLE, GLM_X, GLM_PLUS, GLM_MINUS, GLM_MONITOR, GLM_NETWORK, GLM_THREE_DOTS_HORIZONTAL, GLM_THREE_DOTS_VERTICAL, GLM_CALENDAR_X, GLM_CALENDAR, GLM_CALENDAR_CHECK, GLM_CALENDAR_HEART, GLM_SCAN_TEXT, GLM_PRINTER, GLM_PRINTER_2, GLM_TABLE, GLM_COLUMNS_SETTINGS,
    ]),
  ],
};
